import { ref, onValue, get } from "firebase/database";
import { db } from "./firebaseClient";

const ROOT = "cise";

/**
 * Assina o nó leadsList em tempo real.
 * Retorna função de unsubscribe.
 * @param {(snapshot: object) => void} callback
 * @returns {() => void}
 */
export function subscribeToLeadsList(callback) {
  const leadsRef = ref(db, `${ROOT}/leadsList`);
  const unsubscribe = onValue(leadsRef, (snapshot) => {
    callback(snapshot.val() || {});
  });
  return unsubscribe;
}

/**
 * Assina o histórico de mensagens de um lead específico em tempo real.
 * Retorna função de unsubscribe.
 * @param {string} waId
 * @param {(snapshot: object) => void} callback
 * @returns {() => void}
 */
export function subscribeToLeadHistory(waId, callback) {
  const historyRef = ref(db, `${ROOT}/leads/${waId}/history`);
  const unsubscribe = onValue(historyRef, (snapshot) => {
    callback(snapshot.val() || {});
  });
  return unsubscribe;
}

/**
 * Leitura pontual do estado do atendimento.
 *
 * `cise/leads/{waId}/direct` é o estado canônico da engine: perfis, agendamento,
 * intenção pendente e standby, tudo num nó só. O nó irmão `directView` é apenas
 * uma projeção legível para quem inspeciona o banco pelo console — o painel lê a
 * fonte, não a projeção.
 *
 * @param {string} waId
 * @returns {Promise<object|null>} estado do atendimento, ou null se ainda não existe
 */
export async function fetchLeadDetails(waId) {
  const snapshot = await get(ref(db, `${ROOT}/leads/${waId}/direct`));
  return snapshot.val();
}
